import {
  AssetDocumentArea,
  AssetDocumentZone,
  DonationAnswers,
  DonationsTab,
  SaveDonations,
} from "../../../api/ClientFileApi";
import { ClientFileQueryKey } from "../../../query/clientFileQueryKeys";
import { InventoryUploadAreaConfig } from "../../components/inventory-upload-area/InventoryUploadArea";
import { DonationAnswerField, DonationsFormValues } from "./DonationsView.types";

export type DonationQuestionKey = "gratuitousDispositions" | "otherDispositions" | "assetSettlement";

export interface DonationQuestionConfig {
  key: DonationQuestionKey;
  field: DonationAnswerField;
  detailsField: DonationAnswerField;
}

export const DONATION_QUESTIONS: readonly DonationQuestionConfig[] = [
  {
    key: "gratuitousDispositions",
    field: "hasGratuitousDispositions",
    detailsField: "gratuitousDispositionsDetails",
  },
  { key: "otherDispositions", field: "hasOtherDispositions", detailsField: "otherDispositionsDetails" },
  { key: "assetSettlement", field: "hasAssetSettlement", detailsField: "assetSettlementDetails" },
];

export const DONATIONS_UPLOAD_AREA: InventoryUploadAreaConfig<"donationDocuments"> = {
  area: AssetDocumentArea.Donations,
  zone: AssetDocumentZone.Donations,
  queryKey: ClientFileQueryKey.AssetInventoryDonationDocuments,
  fieldName: "donationDocuments",
};

const EMPTY_ANSWERS: DonationAnswers = {
  hasGratuitousDispositions: null,
  gratuitousDispositionsDetails: null,
  hasOtherDispositions: null,
  otherDispositionsDetails: null,
  hasAssetSettlement: null,
  assetSettlementDetails: null,
};

export function hasAnyYes(answers: DonationAnswers): boolean {
  return DONATION_QUESTIONS.some(({ field }) => answers[field] === true);
}

export function fromDonationsResponse(data: DonationsTab | undefined): DonationsFormValues {
  return {
    answers: data?.answers ?? EMPTY_ANSWERS,
    donationDocuments: [],
    documentMoves: [],
  };
}

export function toDonationsRequest(values: DonationsFormValues): SaveDonations {
  return { answers: values.answers };
}
